import gql from 'graphql-tag';

export const DeleteDispatchIssue = gql`
  mutation DeleteDispatchIssueBulk($input: DeleteDispatchIssueBulkInput!) {
    deleteDispatchIssueBulk(input: $input) {
      deleted
    }
  }
`;
